import classNames from 'classnames';

import './InstructionsBanner.scss';

const InstructionsBannerImagePath = '/public/assets/icons/instructions-banner.png';

interface InstructionsBannerProps {
    className?: string;
    hidden?: boolean;
}

const InstructionsBanner = ({ className = '', hidden = false }: InstructionsBannerProps): JSX.Element => {
    return (
        <img
            src={InstructionsBannerImagePath}
            className={classNames(className, 'InstructionsBanner', { 'InstructionsBanner--hidden': hidden })}
        />
    );
};

export default InstructionsBanner;
